import { Handle, Position } from '@xyflow/react'

export default function RootNode() {
  return (
    <div className="w-[150px] rounded-2xl bg-gradient-to-br from-accent-600 to-fuchsia-600 px-5 py-4 text-center shadow-glow-accent">
      <div className="text-lg font-semibold tracking-tight text-white">MLMate</div>
      <div className="text-[10px] font-medium uppercase tracking-widest text-white/70">learn by running</div>
      <Handle type="source" position={Position.Right} className="!h-2 !w-2 !border-0 !bg-white/50" />
    </div>
  )
}
